const observerSymbol = Symbol('mgLazyVideoObserver');

function prefersReducedMotion() {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

function ensureObserver() {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }
  if (window[observerSymbol]) return window[observerSymbol];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.preload === 'none') video.preload = 'metadata';
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px 200px 0px' }
  );

  window[observerSymbol] = observer;
  return observer;
}

export default {
  bind(el) {
    if (el.tagName !== 'VIDEO') return;

    // The directive owns playback: strip autoplay so the browser doesn't
    // start downloading/playing before the video is anywhere near the viewport
    el.removeAttribute('autoplay');
    el.autoplay = false;
    if (!el.getAttribute('preload')) el.setAttribute('preload', 'none');

    if (prefersReducedMotion()) {
      // Poster only: no motion, no download beyond metadata
      el.setAttribute('preload', 'metadata');
      return;
    }

    const observer = ensureObserver();
    if (observer) {
      observer.observe(el);
    } else {
      const playing = el.play();
      if (playing && playing.catch) playing.catch(() => {});
    }
  },
  unbind(el) {
    const observer =
      typeof window !== 'undefined' ? window[observerSymbol] : null;
    if (observer) observer.unobserve(el);
  },
};
